import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.21.8_@parcel+watcher@2.5.6_@vue+compiler-sfc@3.5.38_cac@6.7.14_db0@0.3.4_eslint@10.5.0_5zv4kvn7jyaejixhdlksd7tnom/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.21.8_@parcel+watcher@2.5.6_@vue+compiler-sfc@3.5.38_cac@6.7.14_db0@0.3.4_eslint@10.5.0_5zv4kvn7jyaejixhdlksd7tnom/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}